<template>
  <div class="ocr-api-error tabs-no-test-div timeout">
    <div class="ocr-api-error-inner">
      <p class="ocr-api-error-text">{{ message }}</p>
      <v-btn
        v-if="showRetry"
        size="small"
        variant="outlined"
        color="primary"
        class="ocr-api-error-retry"
        :loading="retrying"
        @click="$emit('retry')"
      >
        Retry
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "OcrApiErrorPanel",
  props: {
    message: { type: String, required: true },
    showRetry: { type: Boolean, default: true },
    retrying: { type: Boolean, default: false },
  },
  emits: ["retry"],
};
</script>
